import React from 'react';
import { Formik } from 'formik';
import { FormField } from 'components/layout/form-fields/FormField';
import './ClientContactForm.sass';
import * as Yup from 'yup';
import { Switch } from 'components/layout/form-fields/inputs/Switch';

const validationSchema = Yup.object().shape({
	isPrimary: Yup.boolean().required().label('Is Primary'),
	name: Yup.string().required().label('Name'),
	role: Yup.string().required().label('Role'),
	slackId: Yup.string().nullable().label('Slack ID'),
	email: Yup.string().email().nullable().label('Email'),
	phone: Yup.string().nullable().label('Phone')
});

export class ClientContactForm extends React.Component {
	get isEdit() {
		return this.props.data !== null;
	}

	getInitialValues() {
		return {
			isPrimary: false,
			name: '',
			role: '',
			slackId: '',
			email: '',
			phone: ''
		};
	}

	render() {
		return (
			<Formik
				initialValues={{
					...this.getInitialValues(),
					...this.props.data
				}}
				enableReinitialize
				validationSchema={validationSchema}
				onSubmit={values => {
					this.props.onSubmit?.(values);
				}}>
				{formikBag => (
					<div className="ClientContactForm">
						<FormField
							label="Name"
							field="name"
							type="text"
							isInvalid={formikBag.touched.name && formikBag.errors.name}
							{...(this.props.onChange && {
								onChange: e => this.props.onChange('name', e.target.value)
							})}
						/>
						<FormField
							label="Role"
							field="role"
							type="text"
							isInvalid={formikBag.touched.role && formikBag.errors.role}
							{...(this.props.onChange && {
								onChange: e => this.props.onChange('role', e.target.value)
							})}
						/>
						<FormField
							label="Slack ID"
							field="slackId"
							type="text"
							isInvalid={formikBag.touched.slackId && formikBag.errors.slackId}
							{...(this.props.onChange && {
								onChange: e => this.props.onChange('slackId', e.target.value)
							})}
						/>
						<FormField
							label="Email"
							field="email"
							type="email"
							isInvalid={formikBag.touched.email && formikBag.errors.email}
							{...(this.props.onChange && {
								onChange: e => this.props.onChange('email', e.target.value)
							})}
						/>
						<FormField
							label="Phone"
							field="phone"
							type="text"
							isInvalid={formikBag.touched.phone && formikBag.errors.phone}
							{...(this.props.onChange && {
								onChange: e => this.props.onChange('phone', e.target.value)
							})}
						/>
						<Switch
							id="isPrimary"
							value={formikBag.values.isPrimary}
							onValueChange={value => {
								if (this.props.onChange) {
									this.props.onChange('isPrimary', value);
								}
								formikBag.setFieldValue('isPrimary', value);
							}}
							activeLabel="Mark as Primary Contact"
							inactiveLabel="Mark as Primary Contact"
						/>
						{this.props.customButtons?.length &&
							this.props.customButtons.length > 0 && (
								<div className="custom-buttons">
									{this.props.customButtons.map(button => (
										<button
											key={button.label}
											className={`custom-button-${button.variant}`}
											onClick={e => {
												e.preventDefault();
												button.onClick(formikBag);
											}}>
											{button.label}
										</button>
									))}
								</div>
							)}
					</div>
				)}
			</Formik>
		);
	}
}
